/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1BannerPriorityListQueryResponse,
  GetApiV1BannerPriorityList401,
  GetApiV1BannerPriorityList500,
} from "../../types/bannerRegistroController/GetApiV1BannerPriorityList.ts";

function getGetApiV1BannerPriorityListUrl() {
  const res = { method: "GET", url: `/api/v1/banner/priority-list` as const };
  return res;
}

/**
 * @description Retorna as prioridades possíveis do banner (enum EBannerPriority) para dropdown. **(Requer Authorization para autenticação)**
 * @summary Listar prioridades do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/priority-list}
 */
export async function getApiV1BannerPriorityList(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1BannerPriorityListQueryResponse,
    ResponseErrorConfig<
      GetApiV1BannerPriorityList401 | GetApiV1BannerPriorityList500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1BannerPriorityListUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
